<div class="container">
  <div *ngIf="fileExtension(fileData.name!) !== 'PDF'; else pdfFile">
    <div *ngIf="imgURL === null; else previewImage">
      <div class="download-image" *ngIf="isImage(fileData.name!)">
        <img class="download-image-crop" [src]="imageIcon" />
        <app-download-button
          class="download-image-download"
          *ngIf="!fileData.isActive"
          (processChange)="onDownloadClick(fileData, $event)"
        ></app-download-button>
      </div>
    </div>
    <ng-template #previewImage>
      <img
        class="download-image-crop"
        (click)="onDownloadClick(fileData, true)"
        [src]="imgURL"
      />
    </ng-template>
  </div>
  <ng-template #pdfFile>
    <div class="download-image">
      <img class="download-image-crop-pdf" [src]="pdfIcon" />
      <app-download-button
        class="download-image-download"
        *ngIf="!fileData.isActive"
        (processChange)="onDownloadClick(fileData, $event)"
      ></app-download-button>
    </div>
  </ng-template>
  <div class="download-image-about">
    <div class="file-name-container">
      <span class="file-name">{{ fileData.name! }}</span
      ><br />
      <span *ngIf="fileInfoExists()" class="file-info">
        {{ fileExtension(fileData.name!) }} |
        {{ fileSize() }}
      </span>
    </div>

    <div *ngIf="allowDelete">
      <img
        class="remove-file-img"
        (click)="onRemoveFileClick()"
        src="../../../../assets/icons/gray-trash-can.svg"
      />
    </div>
  </div>
</div>
